import keycloak from '../keycloak';

class AuthService {
  // Get the current access token
  getToken() {
    return keycloak.token;
  }

  // Get the refresh token
  getRefreshToken() {
    return keycloak.refreshToken;
  }

  // Check if user is authenticated
  isAuthenticated() {
    return keycloak.authenticated;
  }

  // Get user info
  getUserInfo() {
    return keycloak.tokenParsed;
  }

  // Get user roles
  getUserRoles() {
    return keycloak.tokenParsed?.realm_access?.roles || [];
  }

  // Check if user has required roles for access
  hasRequiredAccess() {
    const userRoles = this.getUserRoles();
    const requiredRoles = ['headoffice', 'admin'];
    
    // Check if user has at least one of the required roles
    const hasAccess = requiredRoles.some(role => userRoles.includes(role));
    
    return hasAccess;
  }

  // Get user's accessible roles (for debugging/display purposes)
  getAccessibleRoles() {
    const userRoles = this.getUserRoles();
    const requiredRoles = ['headoffice', 'admin'];
    
    return userRoles.filter(role => requiredRoles.includes(role));
  }

  // Logout user
  logout() {
    keycloak.logout({
      redirectUri: window.location.origin
    });
  }

  // Update token if needed
  async updateToken(minValidity = 30) {
    try {
      const refreshed = await keycloak.updateToken(minValidity);
      return keycloak.token;
    } catch (error) {
      console.error('Failed to refresh token', error);
      this.logout();
      throw error;
    }
  }

  // Get authorization header for API calls
  getAuthorizationHeader() {
    const token = this.getToken();
    return token ? `Bearer ${token}` : null;
  }
}

// Create instance and export it
const authServiceInstance = new AuthService();
export default authServiceInstance; 